interface FilterChipProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export function FilterChip({ label, isActive, onClick }: FilterChipProps) {
  return (
    <button
      onClick={onClick}
      className={`px-5 py-2.5 rounded-xl whitespace-nowrap font-medium transition-all ${
        isActive
          ? 'bg-splyt-green text-splyt-dark glow-green'
          : 'glass border border-white/10 text-white/70 hover:text-white hover:border-white/20'
      }`}
    >
      {label}
    </button>
  );
}



